export class UnsupportedSwitchingOfChainError extends Error {
  constructor(...args) {
    super(...args)
  }
}
